import axios from "axios"
import { authHeader, baseUrl } from "../../utils"
import { ACADEMIC_SESSIONS_ERROR, CREATE_ACADEMIC_SESSION, CREATING_ACADEMIC_SESSION, GETTING_ACADEMIC_SESSIONS, GET_ACADEMIC_SESSIONS, UPDATE_ACADEMIC_SESSION } from "../types"


export const createAcademicSession = (academicSessionPayload) => async (dispatch) => {    
    try{
        const headers = authHeader()

        dispatch({
            type: CREATING_ACADEMIC_SESSION,
            payload: true
        })

        const response = await axios.post(`${baseUrl}/academic-sessions`, academicSessionPayload, { headers })
        
        dispatch({
            type: CREATE_ACADEMIC_SESSION,
            payload: response.data.data
        })
        
    }
    catch(error){
        dispatch({
            type: ACADEMIC_SESSIONS_ERROR,
            error
        })
    }
}

export const updateAcademicSession = (academicSessionId, academicSessionPayload) => async (dispatch) => {    
    try{
        const headers = authHeader()

        dispatch({
            type: CREATING_ACADEMIC_SESSION,
            payload: true
        })

        const response = await axios.patch(`${baseUrl}/academic-sessions/${academicSessionId}`, academicSessionPayload, { headers })
        
        dispatch({
            type: UPDATE_ACADEMIC_SESSION,
            payload: response.data.data
        })
        
    }
    catch(error){
        dispatch({
            type: ACADEMIC_SESSIONS_ERROR,
            error
        })
    }
}

export const fetchAcademicSessions = (filterString, page, perPage) => async (dispatch) => {    
    try{
        const headers = authHeader()

        let url = `${baseUrl}/academic-sessions`
        if(filterString && filterString !== '') {
            url += `${url.includes('?') ? '&' : '?'}${filterString}`
        }

        if(page && page!=='') {
            url += `${url.includes('?') ? '&' : '?'}page=${page}`
        }

        if(perPage && perPage!=='') {
            url += `${url.includes('?') ? '&' : '?'}perPage=${perPage}`
        }

        dispatch( {
            type: GETTING_ACADEMIC_SESSIONS,
            payload: true
        })

        const response = await axios.get(url, { headers })
        // console.log(response.data.data)
        dispatch({
            type: GET_ACADEMIC_SESSIONS,
            payload: response.data.data
        })
        
    }
    catch(error){
        dispatch( {
            type: ACADEMIC_SESSIONS_ERROR,
            error
        })
    }
}

export const clearCreatedAcademicSession = (filterString, page, perPage) => async (dispatch) => {    
    dispatch({
        type: CREATE_ACADEMIC_SESSION,
        payload: null
    })
}

export const clearUpdatedAcademicSession = (filterString, page, perPage) => async (dispatch) => {    
    dispatch({
        type: UPDATE_ACADEMIC_SESSION,
        payload: null
    })
}